import React from 'react';
import { useSelector } from 'react-redux';
import { getProjectSource } from '../../../features/project/projectSlice';
import usePowerBiUrl from '../../hooks/usePowerBiUrl';
import SyncedInfoLink from './SyncedInfoLink';

const PowerBiSyncInfo = ({ report }) => {
  const baseUrl = usePowerBiUrl();
  const projectSource = useSelector(getProjectSource);
  const powerBiUrl = report
    ? `${baseUrl}/${report.reportId}?workspaceId=${report.workspaceId}&typeId=POWERBI_VIZ&guid=${report.reportId}&type=REPORT`
    : baseUrl;

  return (
    <>
      <SyncedInfoLink
        name={
          projectSource === 'DTP' ? 'DTP' : `${report?.name} ` || 'Workbench'
        }
        url={powerBiUrl}
      />
    </>
  );
};

export default PowerBiSyncInfo;
